<template>
  <v-container fluid class="material-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/material/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="materials-table"
              show-select
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="materialHeaders"
              :items="[
                ...materials.filter(material=>material.materialstatus=='New'), 
                ...materials.filter(material=>material.materialstatus=='Active'),
                ...materials.filter(material=>material.materialstatus=='Inactive'),
              ]"
              :items-per-page="materialPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteDialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Material?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_material.itemname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteDialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteMaterial(delete_material)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.materialimage="{ item }">
                <v-avatar v-if="item.materialimage" size="50">
                  <img v-bind:src="item.materialimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="50">
                  <span class="white--text headline">{{ item.materialname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.materialname="{ item }">
                <a class="primaryConst--text">{{ item.materialname }}</a>
              </template>
              <template v-slot:item.materialstatus="{ item }">
                <v-chip :color="item.materialstatus=='New' ? 'primaryConst white--text' : item.materialstatus=='Active' ? 'success white--text' : 'greyTint white--text'" small>
                  {{ item.materialstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editMaterial(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn v-if="item.materialstatus!='Active'" icon color="primary" @click="deleteMaterialDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MaterialList',
  data() {
    return {
      snackbar: null,
      isDeleteDialog: false,
      delete_material: {},
      materialHeaders: [
        { text: 'Image', value: 'materialimage', width: '5%', sortable: false },
        { text: 'Name', value: 'materialname', width: '30%' },
        { text: 'Status', value: 'materialstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      materialPerPage: 100,
      selected: [],
    };
  },
  computed: {
    ...mapState('Material', ['materials', 'isReceiving', 'isDeleting', 'idToDelete', 'materialsMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('Material', ["getMaterialsRequest","deleteMaterialRequest","updateMaterialRequest","createMaterialRequest"]),
    deleteMaterial(item) {
      this.deleteMaterialRequest({_id: item._id});
      this.isDeleteDialog = false;
    },
    deleteMaterialDialog(item) {
      this.isDeleteDialog = true;
      this.delete_material = {_id: item._id, itemname: item.materialname}
    },
    editMaterial(item) {
      this.$router.push({ name: 'MaterialEdit', params: item })
    },

  },
  mounted () {
    this.getMaterialsRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
